import { get } from 'lodash/object';

export default function (models) {
    return models.filter(model => model.ticketType === null
        && model.reservation === null
        && get(model, 'enabled', null)
        !== null && model.enabled);
}
